import React from "react";
import LinkedInIcon from "mdi-material-ui/Linkedin";

export default function LinkedIn(props) {
  return <LinkedInIcon htmlColor="#0077b5" {...props} />;
}
